import React, { useState } from 'react';
import { NavLink, Redirect } from 'react-router-dom';

import { kayitOl, girisYapilmis } from '../services/authApi';

function Register() {
  const [email, setEmail] = useState('');
  const [sifre, setSifre] = useState('');
  const [sifreTekrar, setSifreTekrar] = useState('');
  const [hata, setHata] = useState('');
  const [gonderiliyor, setGonderiliyor] = useState(false);
  const [kayitOldu, setKayitOldu] = useState(false);

  if (girisYapilmis() || kayitOldu) {
    return <Redirect to="/takip-listem" />;
  }

  function handleSubmit(event) {
    event.preventDefault();
    setHata('');

    if (sifre !== sifreTekrar) {
      setHata('Şifreler eşleşmiyor');
      return;
    }

    setGonderiliyor(true);
    kayitOl(email, sifre)
      .then(() => setKayitOldu(true))
      .catch(err => setHata(err.message))
      .finally(() => setGonderiliyor(false));
  }

  return (
    <div className="flex justify-center">
      <div className="w-full max-w-sm">
        <div className="bg-white rounded-xl border border-slate-200 shadow-sm p-6">
          <div className="text-center text-lg font-bold text-slate-800 mb-1">Kayıt Ol</div>
          <div className="text-center text-sm text-slate-500 mb-5">Kendi takip listenizi oluşturun.</div>

          <form onSubmit={handleSubmit} className="flex flex-col gap-3">
            <input
              name="email" type="email" required placeholder="E-posta"
              value={email} onChange={e => setEmail(e.target.value)}
              className="w-full px-3 py-2 text-sm border border-slate-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-sky-400/40 focus:border-sky-400 transition-all"
            />
            <input
              name="sifre" type="password" required placeholder="Şifre (en az 6 karakter)"
              value={sifre} onChange={e => setSifre(e.target.value)}
              className="w-full px-3 py-2 text-sm border border-slate-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-sky-400/40 focus:border-sky-400 transition-all"
            />
            <input
              name="sifreTekrar" type="password" required placeholder="Şifre (tekrar)"
              value={sifreTekrar} onChange={e => setSifreTekrar(e.target.value)}
              className="w-full px-3 py-2 text-sm border border-slate-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-sky-400/40 focus:border-sky-400 transition-all"
            />
            <button
              type="submit" disabled={gonderiliyor}
              className="w-full px-4 py-2 bg-sky-600 hover:bg-sky-700 disabled:opacity-60 disabled:cursor-not-allowed text-white text-sm font-semibold rounded-lg shadow-sm transition-colors"
            >
              {gonderiliyor ? 'Kayıt oluşturuluyor...' : 'Kayıt Ol'}
            </button>

            {hata && <p className="text-center text-sm text-red-600">{hata}</p>}

            <NavLink to="/login" className="text-center text-xs text-slate-500 hover:text-slate-700">
              Zaten hesabınız var mı? Giriş yapın
            </NavLink>
          </form>
        </div>
      </div>
    </div>
  );
}

export default Register
